import {branch, renderNothing} from 'recompose'

import {skipToken} from '@reduxjs/toolkit/query'
import compose from 'lodash/flowRight'

import withHook from '../../../../../hocs/withHook'
import {getBuildTypeTagsArg} from '../../../../../rest/buildTypeTags'
import {restApi} from '../../../../../services/rest'
import {withVisibility} from '../../../../common/Visible/Visible.hocs'

import Rules from './Rules'
import type {Props} from './Rules.types'

export default compose(
  withVisibility(true),
  withHook(({buildTypeId, isTemplate, isVisible}: Props) => {
    restApi.endpoints.getBuildTypeBuildTags.useQuerySubscription(
      isVisible === true && !isTemplate && buildTypeId != null
        ? getBuildTypeTagsArg(buildTypeId)
        : skipToken,
    )
  }),
  branch(({isTemplate}) => isTemplate, renderNothing),
)(Rules)
